export default {
      id: "ic_share_white-usage",
      viewBox: "0 0 16 18",
      url: "/" + "images/icons.3.109.2.svg#ic_share_white-usage",
      toString: function () {
        return this.url;
      }
    }